import { OptionType } from "../../SelectInput";

type GetSelectedOptions = {
  options: OptionType[];
  selectedOptions: string[];
  defaultOptionLabel: string;
};

export const getSelectedOptionsLabel = (props: GetSelectedOptions): string => {
  const {
    options,
    selectedOptions: _selectedOptions,
    defaultOptionLabel,
  } = props;

  if (!_selectedOptions.length) {
    return defaultOptionLabel;
  }

  if (_selectedOptions.length === options.length) {
    return "Todas las opciones";
  }

  const selectedOptions = options.filter((option) =>
    _selectedOptions.includes(option.value.toString())
  );

  return selectedOptions.map((option) => option.label).join(", ");
};
